/**
 * NAVIGATION.JS
 *
 * Initialization and control for the header menu on desktop and mobile.
 */

import * as GLOBALS from '../globals';
import HighlightedNavigation from './navigation-highlight';
import AlertNotice from './alert-notice';
import Toggle from '../classes/toggle';
import Slideable from '../classes/slideable';

export default class HeaderMenu {

	static init() {
		return new HeaderMenu();
	}

	constructor() {
		const headermenu = document.querySelector('.headermenu');

		if (headermenu === null)
			return;
	
		AlertNotice.init();
	
		const navigationList = headermenu.querySelector('nav');
	
		if (navigationList === null || navigationList.childElementCount === 0)
			return;
	
		this.initHamburgerMenu(headermenu);
	
		if (GLOBALS.ENABLE_DROPDOWN_MENU) {
			this.initDropdownMenu(headermenu);
		}
	
		if (GLOBALS.ENABLE_HIGHLIGHTED_NAVIGATION) {
			HighlightedNavigation.init(navigationList);
		}
	
		if (GLOBALS.ENABLE_TRANSPARENT_HEADER) {
			this.initTransparentHeader(headermenu);
		}
	
		return true;
	}

	/**
	 * Initializes the mobile hamburger menu button to toggle between open/closed.
	 *
	 * @return {boolean} successful?
	 */
	initHamburgerMenu(headermenu) {
		const element = headermenu.querySelector('button[aria-label~="Hamburger"]');
		const navigationElements = headermenu.querySelectorAll('.nav-item');

		if (element === null)
			return;

		const slideableNavigationList = new Slideable(headermenu.querySelector('nav'));
		
		new Toggle(element, () => {
			slideableNavigationList.toggle();
			document.body.classList.toggle("modal-opened");
		});

		if (navigationElements !== null) {
			navigationElements.forEach((navItem) => {
				const link = navItem.querySelector('a');
				link.addEventListener('click', () => {
					if(window.getComputedStyle(element).display === 'block') element.click();
				});
			});
		}
	}

	/**
	 * Initializes the mobile dropdown menu buttons to toggle between open/closed.
	 *
	 * @return {boolean} successful?
	 */
	initDropdownMenu(headermenu) {
		const elements = headermenu.querySelectorAll('.nav-item.has-children');
		
		const burgermenu = headermenu.querySelector('button[aria-label~="Hamburger"]');

		if (elements.length === 0)
			return;

		elements.forEach((navItem) => {
			const dropDownItems = navItem.querySelectorAll('.dd-item');

			dropDownItems.forEach((item) => {
				const link = item.querySelector('a');
				link.addEventListener('click', () => {
					if(window.getComputedStyle(burgermenu).display === 'block') burgermenu.click();
				});
			});

			var dropdown = new Slideable(navItem.querySelector('.dropdown'));
			new Toggle(navItem.querySelector('button'), () => {
				dropdown.toggle();
			});
		});
	}

	/**
	 * Initializes the functionality for the header menu to be transparent at the top of the page and get opaque once the user scrolled down a bit
	 *
	 * @param {Element} headermenu
	 */
	initTransparentHeader(headermenu) {
		if (window.innerWidth < GLOBALS.BREAKPOINT_LG || document.querySelectorAll('.error-page').length > 0)
			return;

		const changeBasedOnScrollOffset = () => {
			let scrollTop = document.documentElement.scrollTop;

			if (scrollTop > (window.innerHeight * 0.5)) {
				headermenu.classList.remove('headermenu-transparent');
			} else headermenu.classList.add('headermenu-transparent');
		};

		window.addEventListener('scroll', changeBasedOnScrollOffset);

		changeBasedOnScrollOffset();
	}
}